import { render, staticRenderFns } from "./DeclareOrderDetail.vue?vue&type=template&id=7ba06bc3&"
import script from "./DeclareOrderDetail.vue?vue&type=script&lang=js&"
export * from "./DeclareOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeclareOrderDetail.vue?vue&type=style&index=0&id=7ba06bc3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports